module.exports = __webpack_public_path__ + "img/horsemackerel.85d84c7c.png";